export function contextmenuDirective() {
	return {
		restrict: 'A',
		scope: false,
		controller: contextmenuDirectiveCtrl,
	};
}

export class contextmenuDirectiveCtrl {
	constructor($rootScope, $scope, $element, $attrs) {
		'ngInject';
		// save injections
		this.$rootScope = $rootScope;
		// save ref to document
		this.document = angular.element(document);
		// bind functions
		this.showContextmenu = this.showContextmenu.bind(this);
		this.hideContextmenu = this.hideContextmenu.bind(this);
		// observe changes to sh-contextmenu attribute
		$attrs.$observe('shContextmenu', (newVal, oldVal) => {
			this.config = $scope.$eval(newVal);
			if (this.eventType) {
				$element.off(this.eventType, this.showContextmenu);
			}
			this.eventType = this.config.event || 'contextmenu';
			$element.on(this.eventType, this.showContextmenu);
		});
		// remove all listeners when scope is destroyed
		$scope.$on('$destroy', () => {
			this.hideContextmenu();
			$element.off(this.eventType, this.showContextmenu);
		});
	}

	showContextmenu(evt) {
		evt.preventDefault();
		this.menu = angular.element(document.querySelector(this.config.target));
		// extend scope with given data
		const menuScope = this.menu.scope();
		if (this.config.data) {
			Object.assign(menuScope, this.config.data);
		}
		menuScope.$apply();
		// display and position
		const top = evt.pageY - window.scrollY;
		const left = evt.pageX - window.scrollX;
		this.menu.css({
			display: '',
			position: 'fixed',
			left: `${left}px`,
			top: `${top}px`,
		});
		// attach to body
		document.body.appendChild(this.menu[0]);
		// read position and make sure it fits in the viewport
		this.keepInViewport(left, top);
		// unselect any selected text
		window.getSelection().removeAllRanges();
		// hide on next click or scroll
		setTimeout(() => {
			this.document.on('click', this.hideContextmenu);
			this.document.on('scroll', this.hideContextmenu);
		}, 0);
	}

	hideContextmenu(evt) {
		// evt && evt.stopImmediatePropagation();
		this.menu &&
			this.menu.css({
				display: 'none',
			});
		this.document.off('click', this.hideContextmenu);
		this.document.off('scroll', this.hideContextmenu);
	}

	keepInViewport(left, top) {
		const rect = this.menu[0].getBoundingClientRect();
		if (left + rect.width > window.innerWidth) {
			// too far right; fly left
			this.menu.css('left', `${left - Math.round(rect.width)}px`);
		}
		if (top + rect.height > window.innerHeight) {
			// too far down: fly upward
			this.menu.css('top', `${top - Math.round(rect.height)}px`);
		}
	}
}
